// useConversationBrief — Polish #11.
//
// Fetches the editorial briefing (past → now → needed) for a conversation.
// The backend returns cached ai_brief when fresh and regenerates when stale.
//
// Cache window: 5 minutes stale-while-revalidate, same shape as the batch
// summaries hook. A briefing is tied to a specific conversation so we
// key by id and re-enable the query whenever the user opens a new thread.
// When the response comes back without a brief (Haiku failure on first
// generation), we simply render nothing — the block hides itself.

import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';

export interface BriefResponse {
  brief: string | null;
  at: string | null;
  stale: boolean;
}

export function useConversationBrief(conversationId: string | undefined) {
  return useQuery<BriefResponse>({
    queryKey: ['conversation-brief', conversationId],
    enabled: !!conversationId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: () => apiGet<BriefResponse>(`/api/conversations/${conversationId}/brief`),
  });
}
